import { connect } from 'react-redux'
import EntertainmentList from '../components/entertainment/EntertainmentList'

const mapStateToProps = (state, _props) => {
  const { osName } = state.osReducer

  return {
    osName,
  }
}

export default connect(
  mapStateToProps
)(EntertainmentList)